import { withTranslation, WithTranslation } from 'react-i18next';
import React, { ChangeEvent, useEffect } from 'react';
import getRegisterReasons, { IRegisterReason } from '../../../../helpers/registerReasons';
import i18n from 'i18next';
import { ReactComponent as NotificationLogo } from '../../../../styles/img/icons/error.svg';
import { IAccountModel } from '../../../../helpers/models/accountModel';
import { ProfessionalStep2FormResultKeys } from './professionalStep2FormModel';
import DropDownField from '../../../form/dropdownField';

export interface IProfessionalStep2ReasonsProps extends WithTranslation {
    readonly?: boolean;
    account: IAccountModel;
}

const ProfessionalStep2Reasons = (props: IProfessionalStep2ReasonsProps) => {
    const { t, readonly, account } = props;

    const handleReasonChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const element = document.querySelector(
            '#registration_reason_other_container > input'
        )! as HTMLInputElement;
        document.getElementById('registration_reason_other_container')!.style.display =
            e.target.value === 'Other' ? 'unset' : 'none';

        if (e.target.value === 'Other') {
            element.setAttribute('required', '');
        } else {
            element.removeAttribute('required');
            element.value = '';
        }
    };

    useEffect(() => {
        const element = document.querySelector(
            '#registration_reason_other_container > input'
        )! as HTMLInputElement;

        document.getElementById('registration_reason_other_container')!.style.display =
            element.value ? 'unset' : 'none';
    }, []);

    const registerReasons = getRegisterReasons(i18n.language).map((item: IRegisterReason) => {
        return (
            <option key={item.name} value={item.value}>
                {item.name}
            </option>
        );
    });

    return (
        <>
            <h2
                className="header-3 header-3--purple registration_form_header"
                id="form_professional_step_2_reason_title"
            >
                {t('form_professional_step_2_reason_title')}
            </h2>
            <div className="registration-column-container">
                <div className="field-container registration-professional-information-container">
                    <DropDownField
                        fieldOptions={registerReasons}
                        fieldName={ProfessionalStep2FormResultKeys.REASON}
                        fieldTitle=""
                        fieldRequired
                        fieldHiddenLabel="form_professional_step_2_reason_title"
                        fieldDisabled={readonly}
                        handleOnChange={handleReasonChange}
                        fieldDefaultValue="form_professional_step_2_register_reason_default"
                        defaultValue={account.reason ?? ''}
                        fieldWeight={6}
                        aria-labelledby="form_professional_step_2_reason_title"
                    />
                    <NotificationLogo
                        id={'form_professional_step_2_register_reason_error_logo'}
                        className="field-error-icon field-error-icon--dropdown"
                    />
                </div>
                <div id="registration_reason_other_container" className="field-container">
                    <input
                        type="text"
                        name={ProfessionalStep2FormResultKeys.REASON_OTHER}
                        id="registration_reason_other"
                        className="field-input field-value"
                        defaultValue={account.reasonOther ?? ''}
                        disabled={readonly}
                        aria-label={t('form_professional_step_2_reason_other_aria_label', {
                            ns: 'accessibility',
                        })}
                        data-set-weight={6}
                    />
                </div>
            </div>
        </>
    );
};

export default withTranslation()(ProfessionalStep2Reasons);
